import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { ISharedPageData } from '@utils/contentful/getSharedPageData/getSharedPageData'
import { mapSecondaryMenuItems } from '@utils/contentful/getSharedPageData/getSharedPageData.utils'
import isEmpty from 'lodash/isEmpty'

const parseSharedPageData = (sharedPageDataFields: any): ISharedPageData => {
  const sharedPageData: ISharedPageData = {
    headerNavbarCategories:
      sharedPageDataFields?.headerNavbarCategories?.map((category) => ({
        categoryName: category?.fields?.pageTitleCardTitle,
        categoryUrl: category?.fields?.slug,
        categoryIconImages:
          category?.fields?.navbarIconImages?.map((image) =>
            mapContentfulImageAsset(image)
          ) || [],
        tags: category?.fields?.navbarTags || [],
        categoryPageNavbarIcons:
          category?.fields?.categoryPageNavigationIcon?.map((image) =>
            mapContentfulImageAsset(image)
          ) || [],
      })) || [],
    headerNavbarIndustries:
      sharedPageDataFields?.headerNavbarIndustries?.map((category) => ({
        categoryName: category?.fields?.pageTitleCardTitle,
        categoryUrl: category?.fields?.slug,
        categoryIconImages:
          category?.fields?.navbarIconImages?.map((image) =>
            mapContentfulImageAsset(image)
          ) || [],
        tags: category?.fields?.navbarTags || [],
        categoryPageNavbarIcons:
          category?.fields?.categoryPageNavigationIcon?.map((image) =>
            mapContentfulImageAsset(image)
          ) || [],
      })) || [],
    footerColumns:
      sharedPageDataFields?.footerColumns
        ?.map((column) => {
          if (isEmpty(column)) {
            return null
          }

          return {
            ...column,
            pages: column.pages?.filter((page) => page?.text && page?.slug),
          }
        })
        .filter(Boolean) || null,
    footerBannerQRcode: {
      h1: sharedPageDataFields?.footerBannerQRcode?.fields?.h1,
      h2: sharedPageDataFields?.footerBannerQRcode?.fields?.h2,
      h3: sharedPageDataFields?.footerBannerQRcode?.fields?.h3,
      contentBlockName:
        sharedPageDataFields?.footerBannerQRcode?.fields?.contentBlockName,
      ctaLabel: sharedPageDataFields?.footerBannerQRcode?.fields?.ctaLabel,
      ctaLink: sharedPageDataFields?.footerBannerQRcode?.fields?.ctaLink,
      primaryImages:
        sharedPageDataFields?.footerBannerQRcode?.fields?.primaryImages,
      secondaryImages:
        sharedPageDataFields?.footerBannerQRcode?.fields?.secondaryImages,
    },
    footerBadge: mapContentfulImageAsset(sharedPageDataFields?.footerBadge),
    navbarPrimaryMenuItems:
      sharedPageDataFields?.navbarPrimaryMenuItems?.map((primaryMenuItem) => ({
        primaryMenuTitle: primaryMenuItem?.fields?.ctaLabel || '',
        primaryMenuLink: primaryMenuItem?.fields?.ctaLink || '',
        secondaryMenuItems:
          mapSecondaryMenuItems(primaryMenuItem?.fields?.primaryReferences) ||
          null,
      })) || null,
    navbarSocialMediaIcons:
      sharedPageDataFields?.navbarSocialMediaIcons?.map((icon) => ({
        socialLink: icon?.fields?.ctaLink || '',
        socialIcon:
          mapContentfulImageAsset(icon?.fields?.primaryImages?.[0]) || null,
        socialIconHover:
          mapContentfulImageAsset(icon?.fields?.primaryImages?.[1]) || null,
      })) || null,
    navbarMobileSidebarFooterLinks:
      sharedPageDataFields?.navbarMobileSidebarFooterLinks?.map((link) => ({
        title: link?.fields?.ctaLabel || '',
        slugOrUrl: link?.fields?.ctaLink || '',
      })) || null,
    navbarMobileTiles:
      sharedPageDataFields?.navbarMobileTiles?.map((tile) => ({
        title: tile?.fields?.title || null,
        titleSize: tile?.fields?.titleSize || null,
        titleColor: tile?.fields?.titleColor || null,
        subtitle: tile?.fields?.subtitle || null,
        subtitleColor: tile?.fields?.subtitleColor || null,
        image: mapContentfulImageAsset(tile?.fields?.image) || null,
        images:
          tile?.fields?.images?.map((asset) =>
            mapContentfulImageAsset(asset)
          ) || null,
        backgroundColor: tile?.fields?.backgroundColor || null,
        blockLink: tile?.fields?.blockLink || null,
        desktopLayout: tile?.fields?.desktopLayout || 'regular',
        mobileLayout: tile?.fields?.mobileLayout || 'regular',
      })) || null,

    announcementBanner: {
      announcements:
        sharedPageDataFields?.announcementBanner?.fields?.announcements?.map(
          (item) => {
            return {
              text: item?.fields?.h1 || null,
              link: item?.fields?.ctaLink || null,
            }
          }
        ) || null,
      secondaryLinks:
        sharedPageDataFields?.announcementBanner?.fields?.secondaryLinks?.map(
          (item) => {
            return {
              text: item?.fields?.h1 || null,
              link: item?.fields?.ctaLink || null,
            }
          }
        ) || null,
      backgroundColor:
        sharedPageDataFields?.announcementBanner?.fields?.backgroundColor ||
        null,
      textColor:
        sharedPageDataFields?.announcementBanner?.fields?.textColor || null,
    },
    footerSignupFormId: sharedPageDataFields?.footerSignupForm,
  }

  return sharedPageData
}

export default parseSharedPageData
